import { TranslationService } from '@/utils/services/TranslationService';

import { GIVEAWAY_PICKER } from '@/lib/routes/publicRoutes';

import { GiveawayPickerWrapper } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper';
import { DrawInProgress } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/DrawInProgress';
import { OptionsWrapper } from '@/components/pages/giveaway-picker/OptionsWrapper';
import { SelectAccountWrapper } from '@/components/pages/giveaway-picker/SelectAccountWrapper';
import { SelectPostWrapper } from '@/components/pages/giveaway-picker/SelectPostWrapper';

const GiveawayPicker = () => {
    return (
        <div className="flex px-8 pb-24 pt-12.5 sm:px-12 lg:px-36">
            <GiveawayPickerWrapper>
                <SelectAccountWrapper />
                <SelectPostWrapper />
                <OptionsWrapper />
                <DrawInProgress />
            </GiveawayPickerWrapper>
        </div>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(GIVEAWAY_PICKER);

export default GiveawayPicker;
